import axios from 'axios'

function normalizeSlide (item) {
  const url = item.image || item.url
  const descriptionRs = item.description_rs ?? item.description ?? ''
  const descriptionEn = item.description_en ?? ''
  return { url, descriptionRs, descriptionEn }
}

const state = {
  slides: []
}

const getters = {
  slides: (state) => state.slides
}

const mutations = {
  setSlides (state, slides) {
    state.slides = Array.isArray(slides) ? slides.map(normalizeSlide) : []
  }
}

const actions = {
  async load ({ commit }) {
    try {
      const { data } = await axios.get('/api/slider')
      const slider = data && data.data ? data.data : null
      const slides = slider && Array.isArray(slider.slides) ? slider.slides : []
      commit('setSlides', slides)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async update ({ commit }, slides) {
    const payload = slides.map((s) => ({
      image: s.url || s.image || '',
      description_rs: s.descriptionRs ?? s.description ?? '',
      description_en: s.descriptionEn ?? ''
    }))
    const { data } = await axios.put('/api/slider', { slides: payload })
    const slider = data && data.data ? data.data : null
    const next = slider && Array.isArray(slider.slides) ? slider.slides : []
    commit('setSlides', next)
    return next
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
